import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../account/auth.service';
import { Location } from '@angular/common';
import { User } from '../account/user.model';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit, AfterViewInit {
  User: User = null;
  userId: string = null;
  constructor(
    public profileService: ProfileService,
    private authService: AuthService,
    private _router: Router,
    private globalService: GlobalService,
    private _location: Location
  ) {}

  goHome() {
    if (this.globalService.fromRegistration == false)
      this._router.navigate(['/home']);
    else {
      // this.globalService.isBack = true;
      this._location.back();
    }
  }

  async ngOnInit() {

    this.globalService.isBack = false;
    this.userId = this.globalService.currentUserId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "MYPROFILE";    
    this.globalService.screenHeader = this.globalService.Get("ACCOUNT_DETAILS");
    });
  }         
}
